/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationSharedPromoCodesRedeemPromoCodeResult
 */
export interface FxIdApplicationSharedPromoCodesRedeemPromoCodeResult {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeResult
     */
    PromoCode: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeResult
     */
    GameSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeResult
     */
    Sku: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationSharedPromoCodesRedeemPromoCodeResult
     */
    PublicOrderId: string;
}

/**
 * Check if a given object implements the FxIdApplicationSharedPromoCodesRedeemPromoCodeResult interface.
 */
export function instanceOfFxIdApplicationSharedPromoCodesRedeemPromoCodeResult(value: object): value is FxIdApplicationSharedPromoCodesRedeemPromoCodeResult {
    if (!('PromoCode' in value) || value['PromoCode'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    if (!('PublicOrderId' in value) || value['PublicOrderId'] === undefined) return false;
    return true;
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSON(json: any): FxIdApplicationSharedPromoCodesRedeemPromoCodeResult {
    return FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSONTyped(json, false);
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationSharedPromoCodesRedeemPromoCodeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'PromoCode': json['PromoCode'],
        'GameSystemName': json['GameSystemName'],
        'Sku': json['Sku'],
        'PublicOrderId': json['PublicOrderId'],
    };
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSON(json: any): FxIdApplicationSharedPromoCodesRedeemPromoCodeResult {
    return FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSONTyped(json, false);
}

export function FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSONTyped(value?: FxIdApplicationSharedPromoCodesRedeemPromoCodeResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PromoCode': value['PromoCode'],
        'GameSystemName': value['GameSystemName'],
        'Sku': value['Sku'],
        'PublicOrderId': value['PublicOrderId'],
    };
}

